import React from 'react'

import { graphql, useLazyLoadQuery } from 'react-relay'
import { Metadata } from '@newComponents/Metadata'
import { Screen } from '@newComponents/Screen'
import { H2 } from '@newComponents/Text'
import { PresentationsScreenListSection } from './PresentationsScreenListSection'
import { PresentationsScreenQuery } from './__generated__/PresentationsScreenQuery.graphql'

export const PresentationsScreen = () => {
  const data = useLazyLoadQuery<PresentationsScreenQuery>(
    graphql`
      query PresentationsScreenQuery {
        ...PresentationsScreenListSection_query
      }
    `,
    {}
  )

  return (
    <>
      <Metadata title='Explore Presentations' />

      <Screen gap='$6'>
        <H2>Explore Presentations</H2>

        <PresentationsScreenListSection query={data} />
      </Screen>
    </>
  )
}

export default PresentationsScreen
